<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section" v-if="investmentsConseqAccount">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.investments_conseq_account.title') }}:
						<span v-if="investmentsConseqAccount.name">{{ investmentsConseqAccount.name }} -</span>
						{{ investmentsConseqAccount.account_id }}
					</h2>
				</header>
				<article>
					<actions-panel>
						<a class="button style-1" @click.prevent="$router.safeBack">
							<span class="inner">{{ $t('general.back') }}</span>
						</a>
					</actions-panel>
					<chart-panels-group :panels-data="panelsData" :charts-data="chartsData" v-if="panelsData.length" :tabs="true"/>
					<p v-else>{{ $t('investments.no_data') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
import investmentsMixin from "@/mixins/investmentsMixin";
import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartPanelsGroup from "@/components/containers/ChartPanelsGroup";
import PanelBoxesContainer from "@/components/containers/PanelBoxesContainer";

export default {
	name: "InvestmentsConseqAccount",
	components: {
		ActionsPanel,
		ChartPanelsGroup,
		PanelBoxesContainer
	},
	mixins: [investmentsMixin],
	computed: {
		investmentsConseqAccount() {
			return this.$store.state.views.investmentsConseqAccount;
		},
		products() {
			let data = [];
			this.investmentsConseqAccount.valuation.forEach(item => {
				data.push(item);
			});

			return data;
		},
		chartsData() {
			let data = [
				this.balanceChart,
				this.portfoliosChart,
			];

			return data;
		},
		balanceChart() {
			let data = this.getBalanceChartOptions();
			data.tabName = this.$t('investments.profit');

			let series = [
				{
					name: this.$t('investments.account_balance'),
					data: [],
				},
				{
					name: this.$t('investments.transactions'),
					data: [],
				}
			];

			this.investmentsConseqAccount.history.forEach(item => {
				let amount = parseFloat(item.BaseValuation);
				series[0].data.push({
					x: item.ValuationDate,
					y: amount.toFixed(2),
				});
			});

			let balance = 0;
			let deposits = this.investmentsConseqAccount.deposits.reverse();
			deposits.forEach(item => {
				let amount = parseFloat(item.AccountCurrAmount);
				if (item.OperationType === 'DEB') {
					amount = amount * -1;
				}

				balance += amount;
				series[1].data.push({
					x: item.SettlementDate,
					y: balance.toFixed(2),
				});
			});

			let currentDate = new Date().toISOString().slice(0, 10);
			series[0].data.push({
				x: currentDate,
				y: this.investmentsConseqAccount.balance,
			});

			series[1].data.push({
				x: currentDate,
				y: balance.toFixed(2),
			});

			data.series = series;

			data.totalBalance = this.investmentsConseqAccount.balance;
			data.totalDeposits = this.investmentsConseqAccount.deposit;
			data.totalWithdrawals = this.investmentsConseqAccount.withdrawal;
			data.totalFees = this.investmentsConseqAccount.fee;
			data.totalReturn = this.investmentsConseqAccount.return;

			return data;
		},
		portfoliosChart() {
			let data = this.getPortfoliosChartOptions();
			data.tabName = this.$t('investments.allocation');

			let series = [];
			let labels = [];
			this.products.forEach(item => {
				series.push(parseFloat(item.BaseValuation));
				labels.push(item.ProductName);
			});

			data.chartOptions.labels = labels;
			data.series = series;

			return data;
		},
		panelsData() {
			let data = [];
			this.investmentsConseqAccount.valuation.forEach(item => {
				let currency = this.getCurrencySymbol(item.PriceCurr);

				let totalBalance = 0;
				let transactions = this.transactions.filter((transaction) => {
					return item.ISIN === transaction.ISIN;
				});

				transactions.forEach(transaction => {
					switch (transaction.OperationType){
						case 'SUB':
						case 'TON':
							totalBalance += parseFloat(transaction.DealAmount);
							break;
						case 'RED':
						case 'TOFF':
							totalBalance -= parseFloat(transaction.DealAmount);
							break;
					}
				});

				let returnPercentage = (parseFloat(item.Valuation) / totalBalance) * 100 - 100;

				data.push({
					id: item.id,
					category: this.$t('investments.fund'),
					name: item.ProductName,
					description: this.$t('investments.fund_balance'),
					price: item.Valuation,
					returnPercentage: item.ISIN ? returnPercentage : false,
					type: 'portfolio',
					portfolioType: 'conseq',
					isin: item.ISIN,
					currency: currency,
					detail: !!item.ISIN,
				});
			});

			return data;
		},
		transactions(){
			return this.investmentsConseqAccount.transactions.reverse();
		},
	}
}
</script>

<style scoped>

</style>